import { CrudServiceBase } from './CrudServiceBase';
import { ClientMatterDataDto } from '@/models/matter/ClientMatterDataDto';
import { ClientMatterDataDropdownDto } from '@/models/matter/ClientMatterDataDropdownDto';

export class ClientMatterDataService extends CrudServiceBase<ClientMatterDataDto> {
  constructor() {
    super('/api/ClientMatterData');
  }

  async getDropdownData(clientId: Guid) : Promise<ClientMatterDataDropdownDto> {
    return await this.client.get(`/dropdown/${clientId}`);
  }
}